"use client";

import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [title, setNewTitle] = useState("");
  const [editFunc, setEditFunc] = useState(null);
  const [searchFunc, setSearchFunc] = useState(null);
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [filterFunc, setFilterFunc] = useState(null);
  const [emergency, setEmergency] = useState(false);
  const [backButton, setBackButton] = useState(true);
  const [backButtonFunc, setBackButtonFunc] = useState(null);
  const [addFunc, setAddFunc] = useState(null);
  const [cartButton, setCartButton] = useState(null);
  const [cartButtonFunc, setCartButtonFunc] = useState(null);

  const setTitle = (newTitle) => {
    setFilterFunc(null);
    setSearchFunc(null);
    setEditFunc(null);
    setBackButtonFunc(null);
    setAddFunc(null);
    setEmergency(false);
    setCartButtonFunc(null);
    setNewTitle(() => newTitle);
  };

  // Getter and setter for editFunc
  const getEditFunc = () => editFunc;
  const setEditFuncWrapper = (func) => setEditFunc(() => func);

  // Getter and setter for searchFunc
  const getSearchFunc = () => searchFunc;
  const setSearchFuncWrapper = (func) => setSearchFunc(() => func);

  // Getter and setter for filterFunc
  const getFilterFunc = () => filterFunc;
  const setFilterFuncWrapper = (func) => setFilterFunc(() => func);

  // Getter and setter for backButtonFunc
  const getBackButtonFunc = () => backButtonFunc;
  const setBackButtonFuncWrapper = (func) => setBackButtonFunc(() => func);

  // Getter and setter for addFunc
  const getAddFunc = () => addFunc;
  const setAddFuncWrapper = (func) => setAddFunc(() => func);

  // Getter and setter for cartButtonFunc
  const getCartButtonFunc = () => cartButtonFunc;
  const setCartButtonFuncWrapper = (func) => setCartButtonFunc(() => func);

  return (
    <HeaderContext.Provider
      value={{
        title,
        setTitle,
        editFunc,
        setEditFunc: setEditFuncWrapper,
        getEditFunc,
        searchFunc,
        searchTriggered,
        setSearchTriggered,
        setSearchFunc: setSearchFuncWrapper,
        getSearchFunc,
        filterFunc,
        setFilterFunc: setFilterFuncWrapper,
        getFilterFunc,
        emergency,
        setEmergency,
        backButton,
        backButtonFunc,
        setBackButtonFunc: setBackButtonFuncWrapper,
        getBackButtonFunc,
        setBackButton,
        addFunc,
        setAddFunc: setAddFuncWrapper,
        getAddFunc,
        cartButton,
        setCartButton,
        cartButtonFunc,
        setCartButtonFunc: setCartButtonFuncWrapper,
        getCartButtonFunc,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

HeaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeaderContext must be used within a HeaderProvider");
  }
  return context;
};
